import React, {useState} from "react";

import IdentityVerificationStyle from "./IdentityVerification.module.css"
import Chip from "../../image/Chakra3_transparent.png";
import {useNavigate} from "react-router-dom";
import * as GroupGameService from "../../api/GroupGameService"
import {useTranslation} from "react-i18next";

export default function IdentityVerification(props) {
    const { t, i18n } = useTranslation('translation', { keyPrefix: 'identityVerification' });
    const nav = useNavigate()
    const [errorMessage, setErrorMessage] = useState()

    function postConfirmIdentity() {
        GroupGameService.confirmIdentity(
            props.gameState.id,
            props.currentPlayer.id,
            props.callGameState,
            () => {
                setErrorMessage(t('errorMessage'))
            }
        )
    }

    function playerChipStyle(chip_color) {
        return Object.assign(
            {
                backgroundImage: "url(" + Chip + ")",
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
                height: "50px",
                width: "50px",
                backgroundColor: chip_color,
                borderRadius: "25px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "bold"
            }
        )
    }

    return (
        <>
            <div className={IdentityVerificationStyle.pageContainer}>
                <div className={IdentityVerificationStyle.messageContainer}>
                    <h3>{t('welcomeToLO')}</h3>
                    <h5>
                        {t('youJoinGroupGame')}
                    </h5>
                    <div className={IdentityVerificationStyle.gameDetails}>
                        <div>
                            {t('gameName')}
                        </div>
                        <div>
                            {props.gameState.name}
                        </div>
                        <div>
                            {t('yourName')}
                        </div>
                        <div>
                            {props.currentPlayer.name}
                        </div>
                        <div>
                            {t('yourChip')}
                        </div>
                        <div style={new playerChipStyle(props.currentPlayer.chip_color)}>
                            {props.currentPlayer.chip_char}
                        </div>
                    </div>
                    <br/>
                    <div className={IdentityVerificationStyle.warnMessage}>
                        <h5>{t('ifItsNotYouMessage')}</h5>
                    </div>
                    <br/>
                    {errorMessage && <>
                        <div className={IdentityVerificationStyle.errorMessage}>
                            {errorMessage}
                         </div>
                        <br/>
                    </>}

                    <div className={IdentityVerificationStyle.verificationControls}>
                        <button className={IdentityVerificationStyle.discardButton} onClick={() => nav("/")}>{t('close')}
                        </button>
                        <button className={IdentityVerificationStyle.confirmButton} onClick={postConfirmIdentity}>{t('confirmIdentity')}</button>
                    </div>

                </div>
            </div>

        </>
    )
}